
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { opportunitySchema, OpportunityFormValues } from "./schema";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export const useOpportunityForm = (
  user: any | null, 
  onSuccess: () => void
) => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const form = useForm<OpportunityFormValues>({
    resolver: zodResolver(opportunitySchema),
    defaultValues: {
      title: "",
      organization: "",
      description: "",
      location: "",
      deadline: "",
      opportunityType: "",
      applicationUrl: "https://",
    },
  });

  const handleSubmit = async (values: OpportunityFormValues) => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to post opportunities",
        variant: "destructive",
      });
      navigate('/auth');
      return;
    }

    try {
      const result = await supabase.from("opportunities").insert({
        title: values.title,
        organization: values.organization,
        description: values.description,
        location: values.location,
        deadline: values.deadline,
        type: values.opportunityType,
        application_url: values.applicationUrl,
        user_id: user.id,
      });

      if (result.error) throw result.error;

      toast({
        title: "Opportunity posted",
        description: "Your opportunity has been successfully posted",
      });

      form.reset();
      onSuccess();
    } catch (error: any) {
      console.error("Error posting opportunity:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to post opportunity. Please try again.",
      });
    }
  };

  return {
    form,
    handleSubmit
  };
};
